import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { EntityConfigService, EntityService } from '../../modules/dto'
import { DtoState } from './dto.state'

@Injectable()
export class DtoEffects {
  constructor(
    private actions$: Actions,
    private store: Store<DtoState>,
    private entityService: EntityService,
    protected entityConfigService: EntityConfigService
  ) {}
}
